define([], () => ({
  REQUEST_POPUPS: 'REQUEST_POPUPS',
  RECEIVE_POPUP_IDS: 'RECEIVE_POPUP_IDS',
  RECEIVE_TEST_POPUPS: 'RECEIVE_TEST_POPUPS',
  RECEIVE_POPUPS: 'RECEIVE_POPUPS',
  INVALIDATE_POPUPS_CACHE: 'INVALIDATE_POPUPS_CACHE',
  ERROR_POPUPS: 'ERROR_POPUPS',
  REQUEST_POPUP: 'REQUEST_POPUP',
  RECEIVE_POPUP: 'RECEIVE_POPUP',
  ERROR_POPUP: 'ERROR_POPUP',
  DELETE_POPUP: 'DELETE_POPUP',
  GENERATE_FORM_POPUP: 'GENERATE_FORM_POPUP',
  UPDATE_POPUP: 'UPDATE_POPUP',
  UPDATE_POPUP_JSON: 'UPDATE_POPUP_JSON',
  UPDATE_POPUP_JSON_COMPONENT: 'UPDATE_POPUP_JSON_COMPONENT',
  UPDATE_POPUP_STATUS_FILTER: 'UPDATE_POPUP_STATUS_FILTER',
  UPDATE_POPUP_TEXT_FILTER: 'UPDATE_POPUP_TEXT_FILTER',
  UPDATE_POPUP_TEMPLATE: 'UPDATE_POPUP_TEMPLATE',
  UPDATE_POPUP_GOAL: 'UPDATE_POPUP_GOAL',
  UPDATE_POPUP_SOCIAL_CHANNEL: 'UPDATE_POPUP_SOCIAL_CHANNEL',
  UPDATE_POPUP_FORM_TYPE: 'UPDATE_POPUP_FORM_TYPE',
  UPDATE_IMPORT_SOURCE: 'UPDATE_IMPORT_SOURCE',
  UPDATE_IMPORT_STATUS: 'UPDATE_IMPORT_STATUS',
  UPDATE_LIST_BUILDER_CANDIDATES: 'UPDATE_LIST_BUILDER_CANDIDATES',
  UPDATE_SCROLL_BOX_CANDIDATES: 'UPDATE_SCROLL_BOX_CANDIDATES',
  UPDATE_SMART_BAR_CANDIDATES: 'UPDATE_SMART_BAR_CANDIDATES',
  UPDATE_WELCOME_MAT_CANDIDATES: 'UPDATE_WELCOME_MAT_CANDIDATES',
  UPDATE_POPUP_ROW_LAYOUT: 'UPDATE_POPUP_ROW_LAYOUT',
  UPDATE_MIGRATE_STATUS: 'UPDATE_MIGRATE_STATUS',
  UPDATE_SCRAPE_STATUS: 'UPDATE_SCRAPE_STATUS',
  SAVE_POPUP: 'SAVE_POPUP',
  REGISTER_UNDO: 'REGISTER_UNDO',
  UNDO_POPUP_CHANGE: 'UNDO_POPUP_CHANGE',
  REDO_POPUP_CHANGE: 'REDO_POPUP_CHANGE',
  START_UNDO_SESSION: 'START_UNDO_SESSION',
  END_UNDO_SESSION: 'END_UNDO_SESSION',

  RECEIVE_CLICK_TRIGGER: 'RECEIVE_CLICK_TRIGGER',
  SAVE_CLICK_TRIGGER: 'SAVE_CLICK_TRIGGER',
  ERROR_CLICK_TRIGGER: 'ERROR_CLICK_TRIGGER',
  UPDATE_CLICK_TRIGGER: 'UPDATE_CLICK_TRIGGER',
  DELETE_CLICK_TRIGGER: 'DELETE_CLICK_TRIGGER',

  RECEIVE_DOWNLOAD_PROGRESS: 'RECEIVE_DOWNLOAD_PROGRESS',

  REQUEST_TEMPLATES: 'REQUEST_TEMPLATES',
  RECEIVE_TEMPLATES: 'RECEIVE_TEMPLATES',
  ERROR_TEMPLATES: 'ERROR_TEMPLATES',
  SAVE_TEMPLATE: 'SAVE_TEMPLATE',
  UPDATE_TEMPLATE_STATUS: 'UPDATE_TEMPLATE_STATUS',
  SAVE_MY_TEMPLATE: 'SAVE_MY_TEMPLATE',
  IS_SAVING_MY_TEMPLATE: 'IS_SAVING_MY_TEMPLATE',

  REQUEST_TESTS: 'REQUEST_TESTS',
  RECEIVE_TESTS: 'RECEIVE_TESTS',
  INVALIDATE_TESTS_CACHE: 'INVALIDATE_TESTS_CACHE',
  ERROR_TESTS: 'ERROR_TESTS',
  REQUEST_TEST: 'REQUEST_TEST',
  RECEIVE_TEST: 'RECEIVE_TEST',
  ERROR_TEST: 'ERROR_TEST',
  UPDATE_VARIANT_WEIGHT: 'UPDATE_VARIANT_WEIGHT',
  UPDATE_TEST_TEXT_FILTER: 'UPDATE_TEST_TEXT_FILTER',

  REQUEST_STATS: 'REQUEST_STATS',
  RECEIVE_STATS: 'RECEIVE_STATS',
  ERROR_STATS: 'ERROR_STATS',

  REQUEST_TEST_STATS: 'REQUEST_TEST_STATS',
  RECEIVE_TEST_STATS: 'RECEIVE_TEST_STATS',
  ERROR_TEST_STATS: 'ERROR_TEST_STATS',

  REQUEST_SETTINGS: 'REQUEST_SETTINGS',
  RECEIVE_SETTINGS: 'RECEIVE_SETTINGS',
  ERROR_SETTINGS: 'ERROR_SETTINGS',
  UPDATE_SETTING: 'UPDATE_SETTING',

  RESIZE_MODAL: 'RESIZE_MODAL',
  UPDATE_APP_STATE: 'UPDATE_APP_STATE',

  REQUEST_AUTO_RESPONSE_EMAILS: 'REQUEST_AUTO_RESPONSE_EMAILS',
  RECEIVE_AUTO_RESPONSE_EMAILS: 'RECEIVE_AUTO_RESPONSE_EMAILS',
  RECEIVE_AUTO_RESPONSE_TEMPLATES: 'RECEIVE_AUTO_RESPONSE_TEMPLATES',
  ADD_AUTO_RESPONSE_EMAIL: 'ADD_AUTO_RESPONSE_EMAIL',
  DELETE_AUTO_RESPONSE_EMAIL: 'DELETE_AUTO_RESPONSE_EMAIL',

  ADD_AUTO_RESPONSE_RULE: 'ADD_AUTO_RESPONSE_RULE',
  REMOVE_AUTO_RESPONSE_RULE: 'REMOVE_AUTO_RESPONSE_RULE',
  TOGGLE_AUTO_RESPONSE_RULE_STATUS: 'TOGGLE_AUTO_RESPONSE_RULE_STATUS',
  SET_AUTO_RESPONSE_RULES_STATUS_FROM_LIST: 'SET_AUTO_RESPONSE_RULES_STATUS_FROM_LIST',
  UPDATE_AUTO_RESPONSE_RULE_NAME: 'UPDATE_AUTO_RESPONSE_RULE_NAME',

  ERROR_AUTO_RESPONSE: 'ERROR_AUTO_RESPONSE',
  ACK_ERROR_AUTO_RESPONSE: 'ACK_ERROR_AUTO_RESPONSE',

  // AppView launch status for determining rerouting
  UPDATE_APPVIEW_LAUNCHED_STATUS: 'UPDATE_APPVIEW_LAUNCHED_STATUS',

  // A universal action called on all requests.
  VALIDATE: 'VALIDATE',
  RECEIVE_SWITCH_PREVIEW: 'RECEIVE_SWITCH_PREVIEW',

  RESET_BREAKPOINT_STYLES: 'RESET_BREAKPOINT_STYLES',
  SET_UNSAVED_DESIGN_FLAG: 'SET_UNSAVED_DESIGN_FLAG',
}));
